<template>
  <v-container class="px-3">
    <v-row class="mx-1">
      <v-col class="pb-1 pt-0" cols="12">
        <h1>Lotes sem cronograma</h1>
        <p>Associe os lotes recebidos automaticamente a um cronograma.</p>
      </v-col>
      <v-col class="py-1" cols="12">
        <LotesFilter
          :prestadores="prestadores"
          :operadoras="listOperadora"
          :getListGrupos="(formData) => getListGrupos(formData)"
          :getOperadoras="(item) => getOperadoras(item)"
        />
      </v-col>
      <v-col class="py-1" cols="12">
        <LotesList
          v-show="showList"
          :listGrupos="listGrupos"
          :listLotes="listLotes"
          :pagination="pagination"
          :paginationGrupo="paginationGrupo"
          :getListGrupos="(page)=>getListGrupos(filter, page)"
          :getListLotes="(item, page) => (getListLotes(item, page), getResponsaveis({grupoEconomico, ...item}))"
          :deleteLoteConfirm="(lotes, grupoSelecionado, selecionarTodos) => deleteLoteConfirm(lotes, grupoSelecionado, selecionarTodos)"
          :showOpen="(selectedLotes, grupoSelecionado, selecionarTodos) => showOpen(selectedLotes, grupoSelecionado, selecionarTodos)"
          :userData="userData"
        />
      </v-col>
      <ModalAssociarCronograma
        :vl_total="vl_total"
        :tableInfo="showTable"
        :listCrono="listCrono"
        :selectedGrupo="selectedGrupo"
        :selectedLotes="selectedLotes"
        :selecionarTodos="selecionarTodos"
        :responsaveis="listResponsavel"
        :showClose="(val) => showClose(val)"
        :associarLoteCronoExistente="(item) => associarLoteCronoExistente(item)"
        :saveCronoEAssociaLote="(item) => confirmAcao(item)"
        :length="length"
      />
    </v-row>
  </v-container>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import LotesFilter from './lotes_sem_cronograma/LotesFilter';
  import LotesList from './lotes_sem_cronograma/LotesList';
  import ModalAssociarCronograma from './lotes_sem_cronograma/ModalAssociarCronograma';
  export default {
    components: {
      LotesFilter,
      LotesList,
      ModalAssociarCronograma,
    },
    data() {
      return {
        filter: null,
        listCrono: [],
        selectedGrupo: {},
        selectedLotes: [],
        showTable: false,
        showList: true,
        listGrupos: [],
        listLotes: [],
        pagination: {
          limit: 10,
          offset: 1,
          current_page: 1,
        },
        paginationGrupo: {
          limit: 20,
          offset: 1,
          current_page: 1,
        },
        prestadores: [],
        searchLote: '',
        vl_total: 0,
        length: null,
        selecionarTodos: false
      };
    },
    computed: {
      ...mapState({
        grupoEconomico: (state) => state.permissions.grupoEconomico,
        grupoEconomicoList: (state) => state.permissions.grupoEconomicoList,
        listOperadora: (state) => state.faturamento.listOperadora,
        listResponsavel: (state) => state.faturamento.listResponsavel,
        userData: (state) => state.userData.userData,
      }),
    },
    mounted() {
      this.prestadores = this.$store.getters[
        'permissions/getPrestadoresByGeco'
      ]();
      let opts = {
        grupoEconomico: this.grupoEconomico,
        limitar: false,
        modulo_operadora: 'faturamento',
      };
      this.getOperadoras(opts);
      // this.getResponsaveis(opts);
      // this.getListGrupos(null, this.grupoEconomico)
    },
    methods: {
      ...mapActions('faturamento', ['getResponsaveis']),
      ...mapActions('permissions', ['getOperadoras']),
      showClose(val) {
        this.showTable = val;
        this.listCrono = [];
        this.selectedGrupo = {};
      },
      // OK GETS MODAL
      showOpen(lotes, grupo, selecionarTodos) {
        this.selecionarTodos = selecionarTodos
        let estado = lotes.filter((el) => el.estado != 'Validado').length > 0;
        if (estado && !selecionarTodos) {
          let paramModal = {
            type: 'warning',
            title: 'Atenção!',
            message: 'Somente lotes <b>Validados</b> podem ser associados ao cronograma.<br> Verifique os lotes selecionados, e desmarque aqueles que não são válidos.',
            callback: null,
            btConfirm: { name: 'Ok', show: true },
            textForm: { show: false },
          };
          this.$store.commit('confirmMessage/showConfirmMessage', paramModal);
        } else {
          let idLotes = lotes.map((el) => el.id);
          let userFatPermissoes = this.userData.Permissao.faturamento;
          let userIsGestor = userFatPermissoes.some((perm) => perm == 'gestor');
          this.vl_total = lotes.reduce((total, item) => total + item.arq_vl_calculado, 0);
          this.length = lotes.length;
          this.selectedGrupo = grupo;
          this.selectedLotes = lotes;
          let obj = {
            query: [
              {
                Modulo: 'faturamento',
                Acao: 'getcronoparalotessemcrono',
                Payload: {
                  grupo_economico: this.grupoEconomico,
                  lotes_id: idLotes,
                  tipo_guia_id: grupo.tipo_guia_id,
                  login_prestador: grupo.login_prestador,
                  owner_id: userIsGestor ? null : this.userData.Id,
                  prestador_id: grupo.prestador_id,
                  operadora_ans_id: grupo.operadora_ans_id,
                },
              },
            ],
          };
          this.$store.dispatch('request/doRequest', obj).then((response) => {
            if (!response || response.isAxiosError || response.error) {
              this.$store.commit('hideLoader');
              return;
            }
            let { dados } = response;
            this.listCrono = dados;
            this.showTable = true;
          });
        }
      },
      getListGrupos(formData, page) {
        this.filter = formData
        this.paginationGrupo.offset = page ? page : 1;
        let obj = {
          query: [
            {
              Modulo: 'faturamento',
              Acao: 'getgruposlotesemcronograma',
              Payload: {
                grupo_economico: this.grupoEconomico,
                prestador_id: formData ? formData.prestador_id : null,
                operadora_ans_id: formData ? formData.operadora_ans_id : null,
                numero_lote: formData ? formData.search : null,
                limit: this.paginationGrupo.limit,
                offset: this.paginationGrupo.offset,
              },
            },
          ],
        };
        this.searchLote = formData ? formData.search : null;
        this.$store.dispatch('request/doRequest', obj).then((response) => {
          if (!response || response.isAxiosError || response.error) {
            this.$store.commit('hideLoader');
            return;
          }
          let { dados, total_pages, current_page } = response;
          this.listGrupos = dados;
          this.paginationGrupo.total_pages = total_pages;
          this.paginationGrupo.offset = current_page;
          this.paginationGrupo.current_page = current_page;
          this.showList = true;
        });
      },
      getListLotes(item, page) {
        this.selectedGrupo = item;
        this.pagination.offset = page ? page : 1;
        let { prestador_id, operadora_ans_id, tipo_guia_id, filter } = item;
        let obj = {
          query: [
            {
              Modulo: 'faturamento',
              Acao: 'getlotessemcronograma',
              Payload: {
                grupo_economico: this.grupoEconomico,
                prestador_id,
                operadora_ans_id,
                tipo_guia_id: tipo_guia_id,
                numero_lote: this.searchLote,
                filtro_estados: filter,
                limit: this.pagination.limit,
                offset: this.pagination.offset,
              },
            },
          ],
        };
        this.$store.dispatch('request/doRequest', obj).then((response) => {
          if (!response || response.isAxiosError || response.error) {
            this.$store.commit('hideLoader');
            return;
          }
          let { dados, total_pages, current_page } = response;
          this.listLotes = dados;
          this.pagination.total_pages = total_pages;
          this.pagination.offset = current_page;
          this.pagination.current_page = current_page;
          this.showList = true;
        });
      },
      //OK CONFIRMAÇÃO DE DELETAR
      deleteLoteConfirm(lotesList, grupo, selecionarTodos) {
        // let { prestador_id } = grupo
        let paramModal = {}
        let lotes = lotesList.reduce((arr, item) => {
          let id = item.id;
          let dt_alteracao = item.dt_alteracao;
          if (item) {
            arr.push({ id, dt_alteracao });
          }
          return arr;
        }, []);
        let estado =
          lotesList.filter((el) => el.estado == 'Em validação').length > 0;
        if (estado && !selecionarTodos) {
          paramModal = {
            type: 'warning',
            title: 'Atenção!',
            message:
              'Lotes em processo de validação não podem ser excluidos.<br> Verifique os lotes selecionados, e desmarque aqueles que estão <b>Em validação</b>.',
            callback: null,
            btConfirm: { name: 'Ok', show: true },
            textForm: { show: false },
          };
        } else {
          let validos =
            lotesList.filter((el) => el.estado == 'Validado').length > 0;
          if (validos && !selecionarTodos) {
            paramModal = {
              type: 'error',
              title: 'Excluir lotes?',
              message:
                'Ao excluir, este lote não estará mais disponível.<br>Essa alteração <b>não</b> poderá ser desfeita.',
              callback: null,
              messageForm: (justificativa) => {
                this.deleteLote(
                  {
                    grupo_economico: this.grupoEconomico,
                    justificativa,
                    is_justificavel: 1,
                    lotes,
                    ...grupo,
                    selecionar_todos: selecionarTodos
                  }
                );
              },
              btConfirm: { name: 'Excluir', show: true, color: 'error' },
              btCancel: { name: 'Não', show: true },
              textForm: {
                label: 'Por que você está excluindo esse lote?',
                show: true,
              },
            };
          } else {
            paramModal = {
              type: 'error',
              title: 'Excluir lotes?',
              message:
                'Ao excluir, estes lotes selecionados não estarão mais disponíveis.<br>Essa alteração <b>não</b> poderá ser desfeita.',
              callback: () => {
                this.deleteLote(
                  {
                    grupo_economico: this.grupoEconomico,
                    is_justificavel: 0,
                    lotes,
                    ...grupo,
                    selecionar_todos: selecionarTodos
                  }
                );
              },
              messageForm: null,
              btConfirm: { name: 'Excluir', show: true, color: 'error' },
              btCancel: { name: 'Não', show: true },
              textForm: { show: false },
            };
          }
        }
        this.$store.commit('confirmMessage/showConfirmMessage', paramModal);
      },
      // OK DELETE
      deleteLote(payload) {
        let {prestador_id} = payload
        let obj = {
          query: [
            {
              Modulo: 'faturamento',
              Acao: 'deletelote',
              Payload: payload,
            },
          ],
        };
        this.$store.dispatch('request/doRequest', obj).then((response) => {
          if (!response || response.isAxiosError || response.erros.length) {
            this.$store.commit('hideLoader');
            return;
          }
          let paramModal = {
            type: 'success',
            title: 'Sucesso',
            message: response.mensagem,
            callback: () => {
              this.saveCallback({ prestador_id });
            },
            btConfirm: { name: 'Ok', show: true },
            btCancel: { show: false },
            textForm: { show: false },
          };
          this.$store.commit('confirmMessage/showConfirmMessage', paramModal);
        });
      },

      // OK ASSOCIAR
      associarLoteCronoExistente(item) {
        let obj = {
          query: [
            {
              Modulo: 'faturamento',
              Acao: 'associarlotesemcronograma',
              Payload: {
                grupo_economico: this.grupoEconomico,
                ...item,
                selecionar_todos: this.selecionarTodos
              },
            },
          ],
        };

        this.$store.dispatch('request/doRequest', obj).then((response) => {
          if (!response || response.isAxiosError || response.error) {
            this.$store.commit('hideLoader');
            return;
          }
          let paramModal = {
            type: 'success',
            title: 'Sucesso!',
            message: response.mensagem ?? 'Associação efetuada com sucesso',
            callback: () => {
              this.saveCallback({ prestador_id: item.prestador_id });
            },
            btConfirm: { name: 'Ok', show: true },
            btCancel: { show: false },
          };
          this.$store.commit('confirmMessage/showConfirmMessage', paramModal);
        });
      },

      confirmAcao(item) {
        if (!item.owner_id) {
          this.saveCallback(item.prestador_id);
          return;
        }
        let paramModal = {
          type: 'info',
          title: 'Confirmar ação',
          message: 'Você poderá editar novamente quando necessário',
          callback: () => this.saveCronoEAssociaLote(item),
          btConfirm: { name: 'Salvar', show: true },
          btCancel: { name: 'Cancelar', show: true },
        };
        this.$store.commit('confirmMessage/showConfirmMessage', paramModal);
      },

      saveCallback(val) {
        this.getListGrupos(val);
        this.showTable = false;
      },

      // OK ADD CRONOGRAMA
      saveCronoEAssociaLote(item) {
        let payload = item;
        let data = {
          query: [
            {
              Modulo: 'faturamento',
              Acao: 'addcronograma',
              Payload: payload,
            },
          ],
        };
        this.$store.dispatch('request/doRequest', data).then((response) => {
          if (!response || response.isAxiosError || !response.sucesso) {
            this.$store.commit('hideLoader');
            return;
          }
          let [cronograma_id] = response.ids;
          let paramModal = {
            type: 'success',
            title: 'Sucesso!',
            message: response.mensagem,
            callback: () => {
              this.associarLoteCronoExistente({ cronograma_id, ...item });
            },
            btConfirm: { name: 'Ok', show: true },
            btCancel: { show: false },
          };
          this.$store.commit('confirmMessage/showConfirmMessage', paramModal);
        });
      }
    },
  };
</script>
